<template>
  <div v-if="links.length !== 3" class="row mt-5">
    <div class="col text-center">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="btn btn-light mx-1">
          {{ link.label }}
        </div>
        <inertia-link
          v-else
          :key="key"
          class="btn btn-light mx-1"
          :class="{ 'bg-white': link.active }"
          :href="link.url"
          >{{ link.label }}</inertia-link
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array,
  },
};
</script>
